module.exports = __webpack_public_path__ + "1ccd8a31ed8ad9bdb359d1a676502e6e.MP3";